import { useQuery } from '@tanstack/react-query';
import { apiFetch } from '@/api/client';
import type { FeatureFlagKey } from '@marketing-hub/shared';
import { useProjectContext } from '@/project/ProjectContext';

type PlatformContext = {
  feature_flags: Record<string, boolean>;
};

/** Resolved flags for current project (global + project override). */
export function useFeatureFlags() {
  const { selectedProjectId } = useProjectContext();
  const q = useQuery({
    queryKey: ['platform-context', selectedProjectId],
    queryFn: () =>
      apiFetch<PlatformContext>(
        `/api/platform/context?project_id=${selectedProjectId ?? ''}`,
      ),
  });

  const flags = q.data?.feature_flags ?? {};

  function isEnabled(key: FeatureFlagKey): boolean {
    return Boolean(flags[key]);
  }

  return { flags, isEnabled, isLoading: q.isLoading, error: q.error };
}
